<template>
    <div v-if="dadosCarregados">
        <b-row class="ml-1">
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>N°/Ano</b></span>
                <br />
                <span class="pos-left">{{ ctrLicOutraUg.NrLicitacao+"/"+ctrLicOutraUg.NrAnoLicitacao }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Modalidade</b></span>
                <br />
                <span class="pos-left">{{ dadosComplementares.DeModalidade }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>UG Responsável</b></span>
                <br />
                <span class="pos-left">{{ dadosComplementares.NmUnidadeGestora }}</span>
            </b-col>
        </b-row>
    </div>
</template>

<script lang="ts">
import { store } from "@/store"
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'
import contratoService from '@/services/licitacoes/contratoService'

import { ContratoLicitacaoOutraUg } from '@/types/licitacoes/contratos/contrato-licitacao-outra-ug'
import { DadosComplementaresCrtLicOutraUg } from '@/types/licitacoes/contratos/dados-complementares-ctr-lic-outra-ug'

const CompProps = Vue.extend({
    name: 'DetalhesContratoLicitacaoOutraUg',
    props: {
        ctrLicOutraUg: {
            type: ContratoLicitacaoOutraUg,
            required: true
        }
    }
})

@Component
export default class DetalhesContratoLicitacaoOutraUg extends mixins(UtilsTS, CompProps) {
    dadosComplementares: DadosComplementaresCrtLicOutraUg;
    dadosCarregados = false

    async created() {
        try {
            store.blockScreen = true
            this.dadosComplementares = await contratoService.buscarDadosComplementaresCrtLicOutraUg(this.ctrLicOutraUg.IdUnidGestoraLicit, this.ctrLicOutraUg.IdModalidade)
            this.dadosCarregados = true
        }
        catch (e: any) {
            console.error('Erro ao montar detalhes do contrato', e)
            this.$router.push("/modulo-licitacoes/contratos/contratos-ordens-fornecimento");
            this.$toast.error(e.message || "Erro ao carregar contrato");
        } finally {
            store.blockScreen = false
        }
    }
}
</script>

<style></style>